import React, { useEffect, useState } from "react";
import { Home, Gamepad2, Info } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import {  FaShieldAlt } from "react-icons/fa";

const BottomNav = () => {
  const location = useLocation();
  const [active, setActive] = useState(location.pathname);

  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

  const navLinks = [
    { title: "Home", icon: Home, href: "/" },
    { title: "Games", icon: Gamepad2, href: "/games" },
    { title: "About", icon: Info, href: "/about" },
    { title: "Privacy", icon: FaShieldAlt, href: "/privacy-policy" },
  ];

  return (
    <div className="fixed overflow-hidden bottom-0 left-0 w-full bg-gray-900 border-t border-gray-700 flex justify-around items-center py-2 z-50">
      {navLinks.map((link) => {
        const Icon = link.icon;
        const isActive = active === link.href;

        return (
          <Link
            key={link.title}
            to={link.href}
            className="flex flex-col items-center gap-0.5 text-xs font-medium transition-all duration-200"
          >
            <Icon
              className={`w-6 h-6 transition-all duration-200 ${
                isActive
                  ? "text-blue-400 stroke-[3]"
                  : "text-gray-400 hover:text-white stroke-[2]"
              }`}
            />
            <span
              className={`transition-all duration-200 ${
                isActive
                  ? "text-blue-400 font-extrabold"
                  : "text-gray-400 hover:text-white font-medium"
              }`}
            >
              {link.title}
            </span>
          </Link>
        );
      })}
    </div>
  );
};

export default BottomNav;
